import { ThirdPartyApiClient } from '@fourthwall/services/dist/ThirdPartyApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useStreamlabsAuthUrlQuery = createQueryHook(ThirdPartyApiClient.getStreamlabsAuthUrl, {
  queryKey: ['streamlabsAuthUrl'],
})
